import logo from '../assets/images/logo.png';
import defaultimg from '../assets/images/defaultimage.png';

const AssetConstants = {
    logo: logo,
    defaultimg:defaultimg

}

export {
    AssetConstants
}
